import { render, staticRenderFns } from "./JsonField.vue?vue&type=template&id=4554aca2&scoped=true&"
import script from "./JsonField.vue?vue&type=script&lang=ts&"
export * from "./JsonField.vue?vue&type=script&lang=ts&"
import style0 from "./JsonField.vue?vue&type=style&index=0&id=4554aca2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4554aca2",
  null
  
)

export default component.exports